import { RootState } from '@reducers';

export const selectDashboard = (state: RootState) => state.userDashboardRouteReducer.dashboardReducer;
